import { useTheme } from '../theme';
import { Icon } from './Icon';

/** Compact control for login/branding chrome. Account preference lives on /account. */
export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const { theme, toggle } = useTheme();
  const nextMode = theme === 'light' ? 'Dark mode' : 'Light mode';
  return (
    <button
      type="button"
      className={`theme-toggle${compact ? ' theme-toggle-compact' : ''}`}
      onClick={toggle}
      aria-label={`Switch to ${nextMode.toLowerCase()}`}
      title={`Switch to ${nextMode.toLowerCase()}`}
    >
      <Icon name={theme === 'light' ? 'moon' : 'sun'} size={16} />
      {!compact && <span>{nextMode}</span>}
    </button>
  );
}
